import { useState } from 'react';

type ModalState = {
    isOpen: boolean;
    message: string;
    isSuccess: boolean;
    // eslint-disable-next-line no-unused-vars
    openModal: (message: string, isSuccess: boolean) => void;
    closeModal: () => void;
};

export default function useModal(): ModalState {
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);

    const openModal = (message: string, isSuccess: boolean) => {
        setMessage(message);
        setIsSuccess(isSuccess);
        setIsOpen(true);
    };

    const closeModal = () => {
        setIsOpen(false);
        setMessage('');
    };

    return { isOpen, message, isSuccess, openModal, closeModal };
}